import { isAllowed } from '../Apollo/allower';
import permissions from '../Apollo/permissions';

export default function isAllowedToTransformEvents() {
  return isAllowed(permissions.playbookTransformation);
}
